import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const createDashboardComponentSchema = z.object({
  generator_klass: optionSchema,
  kind: optionSchema,
});

export type CreateDashboardComponentValidationSchema = z.infer<typeof createDashboardComponentSchema>;

export const updateDashboardComponentSchema = createDashboardComponentSchema.pick({
  kind: true,
});

export type UpdateDashboardComponentValidationSchema = z.infer<typeof updateDashboardComponentSchema>;
